export default "__VITE_ASSET__978292ff__"